import { useState } from "react";

import { ucFirstLetters } from "@aclymatepackages/formatters";
import { ToggleButtons } from "@aclymatepackages/atoms";

import CompanyDataListItem from "./CompanyDataListItem";
import { useCachedFirebaseCrud } from "../../../helpers/firebase";
import { Box, Typography } from "@mui/material";
const InputMeasurementSystemRow = ({ inputMeasurementSystem }) => {
  const { updateAccountData } = useCachedFirebaseCrud();

  const [measurementSystem, setMeasurementSystem] = useState(
    inputMeasurementSystem
  );

  return (
    <CompanyDataListItem
      editingComponent={
        <Box>
          <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
            Choose your preferred input measurement system
          </Typography>

          <ToggleButtons
            size="small"
            value={measurementSystem}
            onChange={(newValue) => {
              setMeasurementSystem(newValue);
              updateAccountData({ inputMeasurementSystem: newValue });
            }}
            buttons={[
              { value: "imperial", name: "Imperial" },
              { value: "metric", name: "Metric" }
            ]}
          />
        </Box>
      }
      primaryText={`${ucFirstLetters(measurementSystem)} Measurement Units`}
      secondaryText="Preferred measurement system"
    />
  );
};
export default InputMeasurementSystemRow;
